import React, { useContext, useEffect } from "react";
// styled components
import {
  Row,
  Col,
  Table,
  Empty,
  Button,
  Divider,
  Input,
  Select,
  Checkbox,
  Popover,
} from "antd";
import { Dropdown, Icon } from "semantic-ui-react";
// hooks
import { useAsignarJurados } from "../../../hooks/useAsignarJurados";
// icons
import { LeftOutlined, RightOutlined, SearchOutlined } from "@ant-design/icons";
// data
import {
  cantidadRegistros,
  LineaEstrategicaOptions,
  EstadosPostulacion,
} from "../../../utils/dataSelectOptions";
import { ModalAsignarJurado } from "./components/ModalAsignarJurado";
import { HomeFilled } from "@ant-design/icons";
import { BreadCrumbAdmin } from "../../../components/Administrador/Breadcrumb/Breadcrumb";
import { Jurados } from "../../../models/JuradosModel/jurados.model";
import { openNotification } from "../../../utils/Notifactions";
import { TemplateContext } from "../../../utils/template_context";
import { ReactComponent as FlechaSelect } from "../../../assets/flecha_select.svg";
import { ReactComponent as IconFlechareg } from "../../../assets/flecha_reg.svg";

const TiposIdentificacion: any = {
  "1": "Grupo Conformado",
  "3": "Persona Natural",
  "2": "Persona Juridica",
};

export const AsignarJurados = () => {
  const {
    allpostulaciones,
    cargarTodasPostulaciones,
    totalregistros,
    cantidadpáginas,
    cambiarCantidadPaginas,
    categorias,
    obtenerCategoriasLineas,
    modalasignarjurados,
    setModalAsignarJurados,
    lineasconvocatoria,
    filtros,
    setFiltros,
    buscarpostulaciones,
    limpiarFiltros,
    setAllPostulaciones,
    postulacionesSeleccionadas,
    agregarPostulacionSeleccionada,
    handleLineaChange,
    cambiarCheckbox,
    datosFiltro,
    toggleSeleccionarTodos
  } = useAsignarJurados();

  const context = useContext(TemplateContext);
  useEffect(() => {
    cargarTodasPostulaciones();
  }, []);
  //   pagination tabla
  function itemRenderTable(current: any, type: any, originalElement: any) {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingRight: "2px" }}
          />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingLeft: "2px" }}
          />
        </span>
      );
    }
    return originalElement;
  }
  //   columns
  const columns: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <>
            <span>{index + 1}</span>
          </>
        );
      },
      fixed: context.device === "lg" ? "left" : false,
    },
    {
      title: "Nombre proyecto",
      //width: 200,
      fixed: context.device === "lg" ? "left" : false,
      render: (datos: any) => {
        return (
          <>
            <span>
              {
                datos.nombre_propuesta &&
                datos.nombre_propuesta.length > 27 ? `${datos.nombre_propuesta.substring(0, 27)}...` : datos.nombre_propuesta
              }
              {/* {datos.linea_convocatoria && datos.linea_convocatoria !== null
                ? lineasconvocatoria.filter((x: any) => x.idlineaconvocatoria === datos.linea_convocatoria)[0].nombre
                : null} */}
            </span>
          </>
        );
      },
    },
    {
      title: "Código propuesta",
      //width: 100,
      dataIndex: "radicado",
      key: "radicado",
    },
    {
      title: "Estado",
      //width: 100,
      render: (datos: any) => {
        // console.log(datos);
        return (
          <>
            <span>
              {datos.estado_jurado === null
                ? "Sin asignar"
                : datos.estado_jurado}
            </span>
          </>
        );
      },
    },
    {
      title: "Línea convocatoria",
      //width: 120,
      render: (datos: any) => {
        return datos.linea_convocatoria.length > 27 ? (
          <Popover content={datos.linea_convocatoria} title="Línea convocatoria">
            <span
              style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}
            >{`${datos.linea_convocatoria.substring(0, 24)}...`}</span>
          </Popover>
        ) : (
          datos.linea_convocatoria
        );
      },
    },
    {
      title: "Categoría",
      //width: 169,
      render: (datos: any) => {
        // console.log(datos);
        return (
          <>
            {datos.categoria_linea_convocatoria}
            {/* <span>{datos.categoria_linea_convocatoria ? datos.categoria_linea_convocatoria[0].value : null}</span> */}
          </>
        );
      },
    },
    {
      title: () => (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Seleccionar todos 
            <Checkbox
              checked={datosFiltro.every((data: any) => data.checked)} // Se marca si todos están seleccionados
              indeterminate={datosFiltro.some((data: any) => data.checked) && !datosFiltro.every((data: any) => data.checked)} // Estado intermedio
              onChange={toggleSeleccionarTodos}
            />
          </Col>
        </Row>
      ),
      width: 120,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any) => (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            <Checkbox
              checked={datos.checked}
              onChange={() => cambiarCheckbox(datos)}
            />
          </Col>
        </Row>
      ),
    }
  ];

  const routes = [
    { nombre: "Gestión jurados" },
    { nombre: "Asignar proyectos a jurados" },
  ];

  return (
    <div className="background-color-F7FBFF height-100">
      <BreadCrumbAdmin routes={routes} />
      <div className="container-fluid ps-md-4 pe-md-4 main-c">
        <div className="title_out_card font-family-Montserrat-SemiBold font-size-14px">
          Asignar proyectos a jurados
        </div>

        <div className="sombra_card" style={{ marginBottom: "20px" }}>
          <div>
            <div className="header_card">
              <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
                Fitrar proyectos
              </div>
            </div>
            <div className="body_card">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <div>
                    <div className="col-12">
                    <label className="font-color-4B4B4B font-family-Montserrat-SemiBold font-size-12px pb-2">Filtrar por palabra clave</label>
                    </div>
                    <div className="col-12">
                      <Input
                        suffix={
                          <SearchOutlined className="font-color-051923bf" />
                        }
                        value={filtros.buscarpalabra}
                        onChange={(e) =>
                          setFiltros({
                            ...filtros,
                            buscarpalabra: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-12 pb-2 ">
                    <label className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B pb-2">Filtrar línea convocatoria</label>
                  </div>
                  <div>
                    <Select
                        showSearch
                        value={filtros.linea_convocatoria}
//                        allowClear
                        optionFilterProp="children"
                        style={{ width: "100%" }}
                        placeholder="Seleccionar..."
                        onChange={(value: any) => handleLineaChange(value)}
                      >
                        {lineasconvocatoria.slice().reverse().map(({ id, nombre }: any) => (
                          <Select.Option key={id} value={id}>
                            {nombre}
                          </Select.Option>
                        ))}
                      </Select>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <div className="row">
                    <div>
                    <label className="font-color-4B4B4B font-family-Montserrat-SemiBold font-size-12px pb-2">Filtrar categoría</label>
                    </div>
                    <div>
                      <Select
                        style={{ width: "100%" }}
                        placeholder="Seleccionar..."
                        onChange={(value: any, option: any) =>
                          setFiltros({ ...filtros, categoria: option.children })
                        }
                      >
                        {categorias.map(({ id, nombre }: any) => (
                          <Select.Option key={id} value={id}>
                            {nombre}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <div className="row">
                    <div className="col-12">
                    <label className="font-color-4B4B4B font-family-Montserrat-SemiBold font-size-12px pb-2">Filtrar estado</label>
                    </div>
                    <div className="col-12">
                      <Select
                        suffixIcon={<FlechaSelect />}
                        value={filtros.estado}
                        allowClear
                        style={{ width: "100%" }}
                        placeholder="Seleccionar..."
                        onChange={(value: any) =>
                          setFiltros({ ...filtros, estado: value })
                        }
                      >
                        <Select.Option key="Asignado" value="Asignado">
                          Asignado
                        </Select.Option>
                        <Select.Option key="Sin asignar" value="Sin asignar">
                          Sin asignar
                        </Select.Option>
                      </Select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="footer_card justify-content-flex-end">
              <Button
                className="button-azul-ghost m-0"
                onClick={limpiarFiltros}
              >
                Limpiar
              </Button>
              <Button
                className="button-blanco-radius m-0"
                onClick={buscarpostulaciones}
              >
                Buscar
              </Button>
            </div>
          </div>
        </div>

        <div
          className="row-shadow"
          style={{ marginBottom: "6%", marginTop: "16px" }}
        >
          <div className="col-12">
            <div className="row">
              <div
                className="col-12 col-md-6 justify-content-flex-start  order-0 font-size-14px font-family-Montserrat-Regular"
                style={{ paddingBottom: "0%" }}
              >
                Lista de proyectos
              </div>
              <div className="col-12 col-md-6 d-flex justify-content-md-end justify-content-between align-content-center align-items-center mb-3">
                <div className="d-flex justify-content-end">
                  <div /* span={21} */ /* className="justify-content-center" */>
                    Total:{" "}
                    <span className="font-color-F28C02">{totalregistros}</span>
                  </div>
                </div>

                <div
                  className="d-flex justify-content-end registos-adminconvocatoria"
                  style={{ width: 200 }}
                >
                  <label className="font-family-Montserrat-Regular  font-size-9px font-color-7E7E7E pe-2 d-flex justify-content-end">
                    Registros por página
                  </label>
                  <Dropdown
                    className="select-registros-adminconvocatoria no-margin justify-content-center d-flex"
                    defaultValue={cantidadpáginas}
                    options={cantidadRegistros}
                    icon={<IconFlechareg/>
                    }
                    onChange={(e, { value }) =>
                      cambiarCantidadPaginas(e, value)
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <Table
                  style={{ borderTop: "1px solid #C4C4C4" }}
                  locale={{
                    emptyText: (
                      <Empty
                        description="No se han diligenciados datos para está sección"
                        style={{ padding: "50px" }}
                      />
                    ),
                  }}
                  pagination={{
                    position: ["bottomRight"],
                    itemRender: itemRenderTable,
                    pageSize: cantidadpáginas,
                  }}
                  dataSource={datosFiltro}
                  columns={columns}
                  size="small"
                  bordered={false}
                  scroll={{ x: 1500, y: 300 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-sticky-footer justify-content-flex-end">
        <div
          className="justify-content-flex-end"
          style={{ paddingRight: "16px" }}
        >
          {/* <Button className="button-blanco-radius">ATRÁS</Button> */}
        </div>
        <div>
          <Button
            className="button-azul-radius width-100"
            onClick={() => {
              if (postulacionesSeleccionadas.length === 0) {
                return openNotification({
                  titulo: "Error",
                  descripcion: "Faltan seleccionar proyectos",
                  placement: "bottomRight",
                });
              }
              return setModalAsignarJurados(true);
            }}
          >
            Asignar jurados
          </Button>
        </div>
      </div>
      {modalasignarjurados && (
        <ModalAsignarJurado
          postulaciones={postulacionesSeleccionadas}
          setPostulaciones={setAllPostulaciones}
          modal={modalasignarjurados}
          AceptarModal={() => setModalAsignarJurados(false)}
          CancelarModal={() => setModalAsignarJurados(false)}
        />
      )}
    </div>
  );
};
